import { combineReducers } from 'redux';
import appActions from './reducers/app-actions/app-actions.reducer';
import auth from './reducers/auth/auth.reducer';

export default combineReducers({
  appActions,
  auth,
});
